const STATUS = {
  REQUESTED: "Requested",
  APPROVED: "Approved",
  DECLINED: "Declined",
  INCOMPLETE: "Incomplete",
};

export default STATUS;
